import { render, staticRenderFns } from "./TrainingRegulations.vue?vue&type=template&id=1067e066&"
import script from "./TrainingRegulations.vue?vue&type=script&lang=js&"
export * from "./TrainingRegulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports